import { tenants } from "utils/tenants";
import { resources as Permissions } from "./Permissions";
import { resources as Roles } from "./Roles";
import SecurityIcon from "@mui/icons-material/Security";

//permissions
export const resources = {
  isMenu: true,
  tenancies: [tenants.MU, tenants.MGU, tenants.SU],
  icon: <SecurityIcon />,
  name: "Сигурност",
  title: "Сигурност",
  subMenu: [Permissions, Roles],
};
